import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import OverflowMenu from '../common/OverflowMenu';
import Table from '../common/table';

import { StyledOverflowMenuWrapper, StyledTableCell } from './style';

const UserRow = ({
  user,
  handleEditRoleButtonClick,
  showEditRoleMenuItem,
  handleRemoveUserButtonClick,
}) => (
  <Table.Row hover>
    <StyledTableCell>
      {user.key} {user.isCurrentUser ? '(You)' : null}
    </StyledTableCell>
    <StyledTableCell>
      {user.email}
    </StyledTableCell>
    <StyledTableCell>
      {user.lastActive ? 'Last sign in: ' : null}{user.lastActive && moment(user.lastActive).format('D MMM, YYYY')}
    </StyledTableCell>
    <StyledTableCell>
      {user.role}
    </StyledTableCell>
    <StyledTableCell>
      {!user.isCurrentUser && showEditRoleMenuItem &&
        <StyledOverflowMenuWrapper>
          <OverflowMenu>
            <OverflowMenu.MenuItem
              onClick={() => {
                OverflowMenu.close();
                handleEditRoleButtonClick({
                  id: user.id,
                  initialRole: user.role,
                  role: user.role,
                });
              }}
            >
              Edit role
            </OverflowMenu.MenuItem>
            <OverflowMenu.MenuItem
              onClick={() => {
                OverflowMenu.close();
                handleRemoveUserButtonClick({
                  id: user.id,
                  name: user.key,
                  hasActiveJobs: user.hasActiveJobs,
                });
              }}
            >
              Remove user
            </OverflowMenu.MenuItem>
          </OverflowMenu>
        </StyledOverflowMenuWrapper>
      }
    </StyledTableCell>
  </Table.Row>
);

UserRow.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    hasActiveJobs: PropTypes.bool,
    id: PropTypes.string,
    isCurrentUser: PropTypes.bool,
    key: PropTypes.string,
    lastActive: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
  handleEditRoleButtonClick: PropTypes.func,
  handleRemoveUserButtonClick: PropTypes.func,
  showEditRoleMenuItem: PropTypes.bool,
};

UserRow.defaultProps = {
  handleEditRoleButtonClick: () => {},
  handleRemoveUserButtonClick: () => {},
  showEditRoleMenuItem: false,
};

export default UserRow;
